export default __webpack_public_path__ + "static/media/support-ticket-gif.312c2803.gif";